import { useSortable } from "@dnd-kit/sortable";

import { cn, getContentThumbnailUrl } from "@/utils";
import { Collection, Playlist, Video } from "@/api";
import { DragVertical } from "@/icons";
import { ContentThumbnail } from "@/components";
import { useState } from "react";

interface PlaylistProps {
  playlist: Playlist;
  content?: Collection | Video;
}

export const ReorderablePlaylist = ({
  playlist: p,
  content,
}: PlaylistProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: p.PlaylistId });

  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    transition,
  };
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div
      {...attributes}
      {...listeners}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      ref={setNodeRef}
      style={style}
      className={cn(isDragging && "opacity-50", "focus-visible:outline-none")}
    >
      <div className="flex items-center justify-start">
        <DragVertical
          className={cn(
            "h-6 w-6 pr-2",
            isFocused ? "text-item-tertiary" : "text-item-secondary",
          )}
        />
        <ContentThumbnail
          className="h-[68px]"
          thumbnail={content ? getContentThumbnailUrl(content) : ""}
        />
        <p className="p1-semibold pl-4">{p.PlaylistName}</p>
      </div>
    </div>
  );
};
